/* Native product-info owns variant selection, sale prices and subscriptions. */
(() => {
  if (customElements.get('felippa-installments')) return;
  customElements.define('felippa-installments', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-live')) return;
      this.productInfo = this.closest('product-info') || this.closest('.shopify-section')?.querySelector('product-info');
      if (!this.productInfo) return;
      const priceNode = this.parentElement.querySelector('[data-product-price]');
      this.observer = new MutationObserver(() => this.refresh());
      if (priceNode) this.observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
      this.refresh();
    }
    refresh() {
      const variant = this.productInfo.getSelectedVariant?.(this.productInfo);
      const button = this.productInfo.querySelector('[data-add-to-cart]:not([data-upsell-btn])');
      const subscription = this.productInfo.getSubscriptionUnitPrices?.(button);
      const price = subscription?.price ?? variant?.price ?? Number(this.dataset.price);
      const count = Math.min(Number(this.dataset.maxCount), Math.floor(price / Number(this.dataset.minimum)));
      this.hidden = !Number.isFinite(price) || price <= 0 || count < Number(this.dataset.minCount);
      if (this.hidden) return;
      this.querySelector('[data-installment-count]').textContent = count;
      const amount = Math.round(price / count);
      if (window.theme?.formatMoney) this.querySelector('[data-installment-amount]').innerHTML = window.theme.formatMoney(
        amount, window.theme.settings.currency_code_enable ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat
      );
      this.dataset.price = price;
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
